import { BasicPlaceholder } from 'components/placeholder'

type PlaceholderItem = 'text' | 'table'

interface InsightsPlaceholderProps {
    items?: PlaceholderItem[]
}

export const InsightsPlaceholder = ({
    items = ['text', 'table'],
}: InsightsPlaceholderProps) => {
    return (
        <div className="placeholder-container" data-testid="placeholder">
            {items.map((item, index) =>
                item === 'text' ? (
                    <BasicPlaceholder key={index} type="text" rows={2} />
                ) : (
                    <BasicPlaceholder
                        key={index}
                        type="table"
                        rows={4}
                        columns={3}
                    />
                ),
            )}
        </div>
    )
}
